import { Call } from '../../assets/icons';
import React from 'react';


export const ContactCard = ({ contact }) => {

  return (
    <>
    <div className="flex items-center gap-2">
    <Call className="w-5 h-5 text-gray-400" />
    <a
      href={`tel:${contact}`}
      className="text-blue-600 hover:text-blue-800 transition-colors duration-200 text-lg"
    >
      {contact}
    </a>
  </div>
  </>)

}